import React from 'react'
import PropTypes from 'prop-types'
import style from './index.module.scss'
import wDeviceFallback from './device-background.png'
import wDeviceBlank from './device-backgroundBlank.png'

const CentreSelectorDevice = ({ homePageInfo, isMobile }) => {
  const getBackground = () => {
    if (isMobile) {
      if (homePageInfo.wDeviceSmall && homePageInfo.wDeviceSmall.url) {
        return homePageInfo.wDeviceSmall.url
      }
    } else if (homePageInfo.wDeviceLarge && homePageInfo.wDeviceLarge.url) {
      return homePageInfo.wDeviceLarge.url
    }
    return wDeviceFallback
  }
  const wDevice = getBackground()

  const fileType =
    wDevice.substring(wDevice.lastIndexOf('.') + 1, wDevice.length) || wDevice
  return (
    <span>
      {fileType.includes('mp4' || 'mpeg' || 'webm' || 'ogg') ? (
        <video
          muted
          autoPlay
          loop
          playsInline
          id="westfield"
          className={style.CentreSelectorContainer}
        >
          <source src={wDevice} type={`video/${fileType}`} />
          <track kind="captions" />
        </video>
      ) : (
        <img
          alt="westfield"
          className={style.CentreSelectorContainer}
          src={wDevice.length > 1 ? wDevice : wDeviceBlank}
        />
      )}
    </span>
  )
}

CentreSelectorDevice.propTypes = {
  homePageInfo: PropTypes.object,
  isMobile: PropTypes.bool,
}
export default CentreSelectorDevice
